import { Enum, EnumType } from 'ts-jenum';

Enum<WellKnownFolderEnum>('value');
export class WellKnownFolderEnum extends EnumType<WellKnownFolderEnum>() {
   static readonly UNKNOWN = new WellKnownFolderEnum(0);
   static readonly INBOX = new WellKnownFolderEnum(-1);
   static readonly SENT = new WellKnownFolderEnum(-2);
   static readonly DELETED = new WellKnownFolderEnum(-3);
   static readonly CALL_LIST = new WellKnownFolderEnum(-4);
   static readonly CALL_HISTORY = new WellKnownFolderEnum(-5);
   static readonly COMPLETED = new WellKnownFolderEnum(-6);
   static readonly CALLER_DETAILS = new WellKnownFolderEnum(-7);
   static readonly TRACKING = new WellKnownFolderEnum(-8);
   static readonly WORK_ITEMS = new WellKnownFolderEnum(-9);
   static readonly OUTBOX = new WellKnownFolderEnum(-10);

   private constructor(public value: number) {
      super();
   }
}
